import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const DeleteIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue872'}</MuiIcon>
        );
    })
